'use strict';
$(document).on('turbo:load turbo:render', () => {
    const $doc: JQuery<Document> = $(document);
    let $searchBox = $doc.find('.search-data');
    let hasError;
    $searchBox.each((ind, el) => {
        let $divWithValidationClass: JQuery = $(el).find('.field_with_errors');
        hasError = $divWithValidationClass.length > 0;
        if(hasError) {
            $divWithValidationClass.removeClass('field_with_errors');
            $(el).addClass('field_with_errors');
        }
    });


    // let $doc = $(document);
    // let $searchData = $doc.find('.search-data');
    //
});